export default "__VITE_ASSET__Dj1$mSRN__"